import React, { useEffect, useState } from "react";
import { GoogleApiWrapper } from "google-maps-react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import GoogleMapReact from "google-map-react";
import { Google_api_key } from "../../utils/Constants";

const PlaceSearch = ({
  lat,
  lng,
  setAddress,
  setLatitude,
  setLongitude,
  setEditedStreet,
  setEditedHouse,
  setEditedApt
}) => {
  const [place, setPlace] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setAddress(place != null ? place.label : "");
    if (place && place.value) {
      setLoading(true);
      setError("");

      const placeId = place?.value?.place_id;

      if (!placeId) {
        setError("Invalid place selected.");
        setLoading(false);
        return;
      }

      const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=${Google_api_key}`;

      fetch(geocodeUrl)
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "OK" && data.results.length > 0) {
            const result = data.results[0];
            const location = result.geometry.location;
            const components = result.address_components;

            const getComponent = (types) =>
              components.find((comp) => types.every((t) => comp.types.includes(t)))?.long_name || "";

            const streetName = getComponent(["route"]);
            const houseNumber = getComponent(["street_number"]);
            const apartmentNumber = getComponent(["subpremise"]);
            setLatitude(location.lat);
            setLongitude(location.lng);
            setAddress(result.formatted_address);
            setEditedStreet(streetName)
            setEditedHouse(houseNumber)
            setEditedApt(apartmentNumber)
          } else {
            setError("Failed to geocode the address.");
          }
        })
        .catch((err) => {
          console.error("Geocode error:", err);
          setError("An error occurred while fetching address.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
    if (!place) {
      setEditedApt('')
      setEditedHouse('')
      setEditedStreet('')
    }
  }, [place, setPlace, setAddress, setLatitude, setLongitude, setEditedStreet, setEditedHouse, setEditedApt])

  return (
    <div className="custom_containers p-2">
      <div style={{ height: "70vh", width: "100%" }}>
        <GooglePlacesAutocomplete
          apiKey={Google_api_key}

          selectProps={{
            place,
            onChange: setPlace,
            placeholder: "Search for a location...",
            isClearable: true,
          }}
        />
        {loading && <p className="mt-2">Fetching location details...</p>}
        {error && <p className="mt-2 text-danger">{error}</p>}

        <div style={{ height: "60vh", marginTop: "15px" }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: Google_api_key,
            }}
            center={{ lat: lat, lng: lng }}
            defaultCenter={{ lat: lat, lng: lng }} // Change to your desired default center
            defaultZoom={10} // Change to your desired default zoom level
          >
          </GoogleMapReact>
        </div>
      </div>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: Google_api_key,
})(PlaceSearch);
